import React, { Component } from "react";
import { connect } from "react-redux";
import { Layout } from "antd";

import SectionHeader from "../layout/SectionHeader";
import Logo from "./Logo";

import { updateWidth, updateHeight } from "../../actions/viewport";

import "./styles/components/Loading.css";

const { Content } = Layout;

class Loading extends Component {
  componentDidMount() {
    this.props.updateWidth(window.innerWidth);
    this.props.updateHeight(window.innerHeight);
  }

  render() {
    return (
      <Content className="loading-wrapper">
        <Logo spin>
          <div className="loading-header">
            <SectionHeader title="Loading" marginBottom="big" />
          </div>
        </Logo>
      </Content>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  updateWidth: width => dispatch(updateWidth(width)),
  updateHeight: height => dispatch(updateHeight(height))
});

export default connect(
  undefined,
  mapDispatchToProps
)(Loading);



// WEBPACK FOOTER //
// ./src/components/layout/Loading.js